import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import { type Dialog, type Pagination, type Sort } from "../types";

const sellerSection = "/sellers/";

export const sellerListPath = sellerSection;

export enum SellerListUrlSortField {
  storeName = "storeName",
  status = "status",
  createdAt = "createdAt",
}

export type SellerListUrlDialog = "approve" | "reject" | "suspend" | "ban" | "activate" | "delete";

type SellerListUrlSort = Sort<SellerListUrlSortField>;
export type SellerListUrlQueryParams = SellerListUrlSort &
  Dialog<SellerListUrlDialog> &
  Pagination & { id?: string; query?: string; status?: string };

export const sellerListUrl = (params?: SellerListUrlQueryParams) =>
  sellerListPath + "?" + stringifyQs(params);

export const sellerPath = (id: string) => urlJoin(sellerSection, id);
export type SellerUrlDialog = "approve" | "reject" | "suspend" | "ban" | "activate";
export type SellerUrlQueryParams = Dialog<SellerUrlDialog>;
export const sellerUrl = (id: string, params?: SellerUrlQueryParams) =>
  sellerPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const sellerAddPath = urlJoin(sellerSection, "add");
export const sellerAddUrl = sellerAddPath;
